import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { WorkflowService } from 'src/app/services';

@Component({
  selector: 'wm-my-application-parcels',
  templateUrl: './my-application-parcels.component.html',
  styleUrls: ['./my-application-parcels.component.css'],
  standalone: false
})
export class MyApplicationParcelsComponent implements OnInit {

  @Input() userId: string;
  @Input() allowMultiples = false;
  @Input() formControls: any[];
  @Input() janus = false;

  @Output() parcelSelected = new EventEmitter<any>();

  form = new UntypedFormGroup({});
  results: any[] = [];

  dataSource = new MatTableDataSource<any>(); //  for janus

  @ViewChild(MatSort) sort!: MatSort;

  allColumns = [
    { key: 'select', label: '' },
    { key: 'parcelId', label: 'Parcel ID' },
    { key: 'address', label: 'Address' },
    { key: 'city', label: 'City' },
    { key: 'owner', label: 'Owner Name' },
    { key: 'acres', label: 'Acres' }
  ];

  displayedColumns = this.allColumns.map(c => c.key);

  constructor(
    private _workflowSvc: WorkflowService,
    private fb: UntypedFormBuilder
  ) {}

  ngOnInit() {
    this.form.addControl('myparcels', this.fb.array([]));
    this.loadMyParcels();
  }

  ngAfterViewInit() {
    if (this.janus) {
      this.dataSource.sort = this.sort;

      this.dataSource.sortingDataAccessor = (item, property) => {
        switch (property) {
          case 'parcelId-label': return item.parcel.parcelID;
          case 'address-label': return item.parcel.address;
          case 'city-label': return item.parcel.city;
          case 'owner-label': return item.parcel.ownerName;
          case 'acres-label': return item.parcel.acres;
          default: return '';
        }
      };
    }
  }

  get myparcels(): UntypedFormArray {
    return this.form.get('myparcels') as UntypedFormArray;
  }

  loadMyParcels() {
    this._workflowSvc.getUserParcels(this.userId).subscribe(results => {
      this.results = results;

      results.forEach(r => this.addParcelControl(r));

      if (this.janus) {
        this.dataSource.data = this.myparcels.controls;
      }

      this.updateParcelControls();
    });
  }

  addParcelControl(parcel: any) {
    this.myparcels.push(
      this.fb.group({
        parcelId: [parcel.parcelID],
        selected: [false],
        parcel: [parcel]
      })
    );
  }

  toggleColumn(columnKey: string) {
    if (this.displayedColumns.includes(columnKey)) {
      this.displayedColumns = this.displayedColumns.filter(c => c !== columnKey);
    } else {
      this.displayedColumns = this.allColumns
        .map(c => c.key)
        .filter(k => this.displayedColumns.includes(k) || k === columnKey);
    }
  }

  updateParcelControls() {
    if (!this.formControls) return;

    this.myparcels.controls.forEach(ctrl => {
      const match = this.formControls.find(f => f.parcelID === ctrl.value.parcelId);
      ctrl.patchValue({ selected: !!match });
    });
  }

  selectParcel(control: any) {
    if (!this.allowMultiples) {
      this.myparcels.controls.forEach(c => c.patchValue({ selected: false }));
      control.patchValue({ selected: true });
    }
    this.parcelSelected.emit(control.value.parcel);
  }
}
